/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rewards_Page_Meta_DescriptionInputs */

const en_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track live Glider promotions, referral activity, point boosts, and limited-time rewards.`)
};

const de_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen Sie laufende Glider-Aktionen, Empfehlungsaktivitäten, Punkteboni und zeitlich begrenzte Prämien.`)
};

const pt_br2_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe promoções ativas da Glider, atividades de indicação, bônus de pontos e recompensas por tempo limitado.`)
};

const tr_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif Glider promosyonlarını, davet etkinliğini, puan bonuslarını ve süreli ödülleri takip edin.`)
};

const zh_cn2_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追踪 Glider 的实时推广活动、推荐动态、积分加成和限时奖励。`)
};

const zh_hk2_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤 Glider 的即時推廣活動、推薦活動、積分加成及限時獎賞。`)
};

const ko_kr2_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 중인 Glider 프로모션, 추천 활동, 포인트 부스트, 한정 리워드를 확인하세요.`)
};

const ru_ru2_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следите за активными акциями Glider, реферальной активностью, бонусными баллами и вознаграждениями с ограниченным сроком.`)
};

const es_419_rewards_page_meta_description = /** @type {(inputs: Rewards_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue las promociones activas de Glider, la actividad de referidos, los impulsos de puntos y las recompensas por tiempo limitado.`)
};

/**
* | output |
* | --- |
* | "Track live Glider promotions, referral activity, point boosts, and limited-time rewards." |
*
* @param {Rewards_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const rewards_page_meta_description = /** @type {((inputs?: Rewards_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rewards_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rewards_page_meta_description(inputs)
	if (locale === "de") return de_rewards_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rewards_page_meta_description(inputs)
	if (locale === "tr") return tr_rewards_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_rewards_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_rewards_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_rewards_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_rewards_page_meta_description(inputs)
	return es_419_rewards_page_meta_description(inputs)
});